import MuiToggleButton from "@mui/material/ToggleButton";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export const ToggleButton = MuiToggleButton;

export default MuiToggleButtonGroup;
